module.exports = __webpack_public_path__ + "62zMRbUQkDDyPCw-E/tandc_icon.svg";